import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
/**
 * A Growler Action is a button that allows the user to perform actions in the Growler.
 * By default, the actions will dismiss the Growler after invoking the function
 * provided to the optional `onClick` property.
 */
const GrowlerAction = ({ children, onClick, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    return (_jsx("button", { className: buildClassName('skyline-text-button-2 text-primary-blue-on-dark h-6 rounded-lg px-2', 'cursor-pointer border-none bg-transparent hover:underline', 'focus-visible:outline-primary-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2', 'shrink-0'), onClick: (e) => {
            e.stopPropagation();
            if (onClick)
                onClick();
        }, type: "button", ...dataAttributes, children: children }));
};
export default GrowlerAction;
//# sourceMappingURL=GrowlerAction.js.map